import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch, useHistory } from "react-router-dom";

import { fetchGatings } from "actions/gating";
import { fetchPage, searchPages } from "actions/pages";
import {
  createGatingConfig, updateGatingConfig, deleteGatingConfig
} from 'actions/storyboard';

import _ from 'lodash';
import shortid from "shortid";
import cx from 'classnames';
import Truncate from "react-truncate";

import {
  Button
} from "react-bootstrap";

import styles from './websiteSettings.module.scss';
import GatingConfigurations from "components/gatings";

export const ContentGating = ({ storyboard }) => {
  const dispatch = useDispatch();

  const fetched = useSelector(state => _.get(state, 'pages.fetched', false));
  const gatingConfigs = useSelector((state) => _.get(state, "storyboards.storyboard.item.gatingConfigurations", [])) || [];

  useEffect(() => {
    if (!fetched) {
      fetchPages();
    }

    if (storyboard.page) {
      if (storyboard.page && storyboard.type === 'INTERACTIVE_CONTENT') {
        dispatch(fetchPage(storyboard.page.id));
      }
    }
  }, []);

  const createNewGating = () => {
    var request = {
      uid: shortid(),
      name: 'Untitled Gating',
      enabled: false,
      optional: false,
      trigger: { type: 'TIME', value: 10 },
      target: null
    }

    dispatch(createGatingConfig(request));
  }

  const fetchPages = () => {
    if (storyboard && storyboard.type !== 'INTERACTIVE_CONTENT') {
      var request = {
        storyboard: storyboard.id
      }

      dispatch(searchPages(request, 0, 50));
    }
  }

  const handleUpdate = (id, request) => {
    dispatch(updateGatingConfig(id, request));
  }

  const  handleDelete = (id) => {
    dispatch(deleteGatingConfig(id)); 
  }

  return (
    <div id="contentGating" className={cx(styles.gatingConatiner)}>
      <div className={styles.headerSection}>
        <SiteSettingHeader
          title='Content Gating'
          description='Gating helps generate leads and personalize your marketing efforts.'
        />
        <div className={styles.newGatingSection}>
          <Button variant="secondary" onClick={createNewGating} className={styles.createGatingButton}><i className={cx('cleverstory-plus', styles.addIcon)} />New Gating</Button>
        </div>
      </div>
      {
        gatingConfigs.map((gatingConfig, index) => (
          <GatingConfigurations key={index}
            gatingConfig={gatingConfig}
            storyboard={storyboard}
            onUpdate={handleUpdate}
            onDelete={handleDelete}
            type={"page"} />
        ))
      }
    </div>
  )
}

const SiteSettingHeader = ({ title, description }) => {

  return (
    <header className={styles.siteSettingsHeader}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
    </header>
  )
}